<template>
  <Notification :messages="props.flash.message" />
  <slot />
</template>

<script setup>
import Notification from "@/Shared/Ui/Notifications.vue";
import {watchEffect} from "vue";
import Notifications from "@/Support/Notifications";
const props = defineProps({
    flash: Object
});

const wait = timeout => new Promise(res => setTimeout(() => res(), timeout));

watchEffect(async () => {
    if (!props.flash.message) {
        return;
    }

    for (let message of props.flash.message) {
        await wait(200);
        Notifications.add(message);
    }
});
</script>
